export const ReferBigLockIcon: React.FC<
  React.SVGAttributes<NonNullable<unknown>>
> = (props) => {
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_10457_1672)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.002 20.8c0-5.727 4.068-9.801 9.784-9.801h22.362c5.717 0 9.785 4.075 9.785 9.8v23.1c0 5.026-4.069 9.1-9.086 9.1h-23.76c-5.017 0-9.085-4.075-9.085-9.1v-23.1z"
          fill="#fff"
          stroke="#8065C9"
        />
      </g>
      <rect
        x={22.0078}
        y={28.999}
        width={19}
        height={12}
        rx={3}
        fill="#E7DEFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.012 28.053V26.75a6.75 6.75 0 0113.5 0v1.303c.227.017.44.037.642.064.9.12 1.658.38 2.26.982.602.602.86 1.36.982 2.26.116.866.116 1.97.116 3.337v.11c0 1.367 0 2.47-.116 3.337-.122.9-.38 1.657-.982 2.26-.602.602-1.36.86-2.26.982-.867.116-1.97.116-3.337.116h-8.11c-1.367 0-2.47 0-3.337-.116-.9-.122-1.658-.38-2.26-.982-.602-.602-.86-1.36-.981-2.26-.117-.867-.117-1.97-.117-3.337v-.11c0-1.367 0-2.47.117-3.337.12-.9.38-1.659.98-2.26.603-.602 1.36-.86 2.26-.982.214-.028.428-.05.643-.064zm1.5-1.303a5.25 5.25 0 1110.5 0v1.253C36.639 28 36.24 28 35.817 28h-8.11c-.423 0-.821 0-1.195.003V26.75zm-3.341 3.41c.277-.277.665-.457 1.4-.556.754-.101 1.756-.104 3.19-.104h8c1.436 0 2.437.003 3.193.104.734.099 1.122.28 1.399.556.277.276.457.665.556 1.4.1.755.103 1.756.103 3.19 0 1.435-.002 2.437-.103 3.193-.1.733-.28 1.122-.556 1.399-.277.276-.665.456-1.4.556-.755.1-1.756.102-3.191.102h-8c-1.435 0-2.437-.002-3.192-.102-.734-.1-1.122-.28-1.4-.556-.276-.277-.456-.666-.555-1.4-.101-.755-.103-1.757-.103-3.191 0-1.435.002-2.438.103-3.192.099-.735.28-1.123.556-1.4z"
        fill="#8065C9"
      />
      <defs>
        <filter
          id="filter0_d_10457_1672"
          x={0.501953}
          y={0.499023}
          width={62.9316}
          height={63}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10457_1672"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10457_1672"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ReferBigLockIcon;
